import { bgoStore, ns } from "./rdfService";

export default {

}